import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ClientGroupViewLayer from "../components/ClientGroupViewLayer";

const ClientGroupViewPage = () => {
  return (
    <>
      <MasterLayout>
        <ClientGroupViewLayer />
      </MasterLayout>
    </>
  );
};

export default ClientGroupViewPage;
